export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
  link: string;
  cta: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'h1',
    title: '星际回响',
    subtitle: '一场关于孤独与回响的太空之旅，上映三周票房突破 12 亿。',
    tag: '热映电影',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20lone%20astronaut%20before%20a%20giant%20glowing%20amber%20planet%2C%20deep%20space%20nebula%2C%20dramatic%20warm%20lighting%2C%20dark%20background%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=peach-hero-01&orientation=landscape',
    link: '/detail/m01',
    cta: '查看影片详情',
  },
  {
    id: 'h2',
    title: '2026 秋季档剧集前瞻',
    subtitle: '年代、都市与奇幻三线齐发，你的追剧清单又要变长了。',
    tag: '最新资讯',
    image:
      'https://readdy.ai/api/search-image?query=Autumn%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%20and%20dramatic%20clouds%2C%20cinematic%20amber%20tones%2C%20moody%20atmosphere%20with%20dark%20areas%20for%20text%2C%20high%20detail&width=1600&height=900&seq=peach-hero-02&orientation=landscape',
    link: '/news/detail/n02',
    cta: '阅读资讯',
  },
  {
    id: 'h3',
    title: '长安夜行录',
    subtitle: '巡夜人卷入诡谲谜案，揭开笼罩长安城百年的隐秘。',
    tag: '热播剧集',
    image:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20lantern-lit%20palace%20at%20night%20with%20mist%2C%20rich%20amber%20and%20deep%20red%20tones%2C%20ornate%20architecture%2C%20dark%20cinematic%20areas%20for%20text%2C%20high%20detail&width=1600&height=900&seq=peach-hero-03&orientation=landscape',
    link: '/detail/m09',
    cta: '查看影片详情',
  },
  {
    id: 'h4',
    title: '暗夜追凶',
    subtitle: '十年悬案迎来关键反转，终极预告曝出三个致命疑问。',
    tag: '悬疑新片',
    image:
      'https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20a%20shadowy%20silhouette%2C%20tense%20cinematic%20mood%2C%20orange%20and%20teal%20accents%2C%20dark%20areas%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=peach-hero-04&orientation=landscape',
    link: '/detail/m03',
    cta: '查看影片详情',
  },
];